module.exports = "https://r.nearpod.com/assets/media/image/flipgrid-0da4c59827dce0c1efffff2ac08b5911.svg";